/* eslint-disable ember/no-runloop */ import { template } from "@ember/template-compiler";
import { action } from '@ember/object';
import { run } from '@ember/runloop';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { eq } from 'ember-truth-helpers';
import WrDivider from 'ember-wiser/components/wr/divider';
import WrForm from 'ember-wiser/components/wr/form';
import WrLinkTo from 'ember-wiser/components/wr/link-to';
import OpenIdConnectButton from 'parog-web/components/authentication/open-id-connect-button';
import type AphpConnectMedic from 'parog-web/services/aphp-connect-medic';
import type ProSanteConnect from 'parog-web/services/pro-sante-connect';
import emberSwal from 'ui-kit/utils/ember-swal';
export interface Signature {
    Args: {
        model: {
            email?: string;
        };
        userType: 'patient' | 'medic';
    };
}
export default class LoginPasswordCreationInstructionsComponent extends Component<Signature> {
    @service
    requestManager;
    @service
    proSanteConnect: ProSanteConnect;
    @service
    aphpConnectMedic: AphpConnectMedic;
    get atLeastOneOpenIdConnectServiceEnabled() {
        return this.proSanteConnect.isEnabled || this.aphpConnectMedic.isEnabled;
    }
    @action
    async sendInstructions() {
        if (!this.args.model.email) {
            run(()=>{
                emberSwal.fire('Vous devez entrer un email');
            });
            return;
        }
        const data1 = JSON.stringify({
            auth: {
                email: this.args.model.email,
                user_type: this.args.userType
            }
        });
        await this.requestManager.request({
            url: '/api/v1/send_instructions',
            method: 'POST',
            body: data1
        });
        this.showDialog({
            title: 'Vous allez recevoir un email',
            text: "Si l’adresse mail renseignée correspond à un compte existant, vous recevrez un nouveau lien d'authentification sur cette même adresse.",
            icon: 'success'
        });
    }
    showDialog(options1, callbackAction1?: () => void) {
        return run(()=>{
            emberSwal.fire(options1).then(()=>{
                run(()=>{
                    callbackAction1?.();
                });
            });
        });
    }
    static{
        template(`
    <div class='flex flex-col gap-6'>

      <h2 class='text-h2 text-purple text-center font-sans'>
        Créer/réinitialiser
        <br />
        votre mot de passe
      </h2>

      <WrForm
        @data={{@model}}
        @onSubmit={{this.sendInstructions}}
        class='mx-auto flex w-full flex-col items-center gap-6 sm:w-[400px]'
        as |form|
      >
        <form.Input
          @name='email'
          aria-label='Votre adresse e-mail'
          type='text'
          placeholder='Votre adresse e-mail'
          data-test-login='email'
        />

        <form.SubmitButton type='submit' @icon='ArrowRight'>
          Recevoir l'e-mail
        </form.SubmitButton>

        <p class='text-center'>
          Nous allons vous envoyer un email contenant un lien qui vous permettra
          de créer votre mot de passe.
          <br />
          Si vous ne le recevez pas, pensez à vérifier vos spams.
        </p>
      </WrForm>

      {{#if (eq @userType 'medic')}}
        {{#if this.atLeastOneOpenIdConnectServiceEnabled}}
          <WrDivider>ou</WrDivider>

          <OpenIdConnectButton
            @openIdConnectService={{this.proSanteConnect}}
            class='w-[220px] self-center'
          />

          <OpenIdConnectButton
            @openIdConnectService={{this.aphpConnectMedic}}
            class='self-center'
          />
        {{/if}}
      {{else}}
        <WrDivider>ou</WrDivider>

        <WrLinkTo @route='login.patient-link' class='text-center'>
          Je reçois un lien de connexion
        </WrLinkTo>
      {{/if}}
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
